import type { ReactNode } from 'react';

/**
 * Standard page frame for everything except the full-bleed marketing homepage.
 * `narrow` is the auth/form width; `default` is the app content width.
 */
export function PageContainer({
  children,
  width = 'default',
}: {
  children: ReactNode;
  width?: 'default' | 'narrow';
}) {
  return (
    <div className="container-page py-12 sm:py-16">
      <div className={width === 'narrow' ? 'mx-auto w-full max-w-md' : 'mx-auto w-full max-w-5xl'}>
        {children}
      </div>
    </div>
  );
}
